import { Megaphone, Clock, ArrowRight } from "lucide-react";
import { useSiteConfig } from "@/context/SiteConfigContext";
import { STATUS_META } from "@/data/content";
import { ApplyButton } from "@/components/site/AdmissionBadge";

export function AnnouncementBar() {
  const { config } = useSiteConfig();
  const meta = STATUS_META[config.admissionStatus] || STATUS_META.OPEN;
  const closed = config.admissionStatus === "CLOSED";

  return (
    <div
      className="relative overflow-hidden text-white"
      style={{ background: closed ? "var(--red)" : "linear-gradient(90deg,#0A1E4E,#16347A)" }}
      data-testid="dynamic-admission-banner"
    >
      <div className="container-x flex flex-col sm:flex-row items-center justify-center gap-x-6 gap-y-2 py-3">
        <div className="flex items-center gap-3 text-center sm:text-left">
          <span className="hidden sm:flex h-9 w-9 items-center justify-center rounded-full bg-white/10">
            <Megaphone size={16} className="text-[#D4AF37]" />
          </span>
          <div className="text-sm">
            <span className="font-bold uppercase tracking-wide text-[#D4AF37]" data-testid="banner-status-label">
              {meta.label}
            </span>
            <span className="mx-2 text-white/40">•</span>
            <span className="font-semibold">{config.academicSession} Academic Session</span>
            {!closed && config.deadline && (
              <span className="ml-2 inline-flex items-center gap-1 text-blue-100/80">
                <Clock size={13} /> Deadline: {config.deadline}
              </span>
            )}
          </div>
        </div>
        <ApplyButton className="btn-apply-bright whitespace-nowrap" testId="banner-apply-button">
          {config.bannerCtaLabel || "Apply Now"} <ArrowRight size={18} />
        </ApplyButton>
      </div>
    </div>
  );
}
